import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const COLORS = ['#FBBF24', '#F472B6', '#34D399', '#60A5FA', '#C084FC', '#FB7185', '#22D3EE'];

// A celebratory burst of confetti + stars. Mount when `show` is true.
export function Confetti({ show, count = 40 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        x: (Math.random() - 0.5) * 2, // -1..1
        rot: Math.random() * 360,
        color: COLORS[i % COLORS.length],
        size: 8 + Math.random() * 10,
        delay: Math.random() * 0.25,
        drift: (Math.random() - 0.5) * 260,
        star: Math.random() > 0.6,
      })),
    [count]
  );

  if (!show) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" aria-hidden>
      {pieces.map((p) => (
        <motion.div
          key={p.id}
          initial={{ x: 0, y: -40, opacity: 1, rotate: 0 }}
          animate={{
            x: p.drift,
            y: typeof window !== 'undefined' ? window.innerHeight + 60 : 900,
            rotate: p.rot + 360,
            opacity: [1, 1, 0.9, 0],
          }}
          transition={{ duration: 1.8 + Math.random(), delay: p.delay, ease: 'easeIn' }}
          style={{
            position: 'absolute',
            left: `${50 + p.x * 40}%`,
            top: 0,
          }}
        >
          {p.star ? (
            <svg width={p.size + 4} height={p.size + 4} viewBox="0 0 24 24" fill={p.color}>
              <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4 7.3 13.6 2.2 9l6.9-.7z" />
            </svg>
          ) : (
            <div
              style={{
                width: p.size,
                height: p.size * 0.6,
                background: p.color,
                borderRadius: 3,
              }}
            />
          )}
        </motion.div>
      ))}
    </div>
  );
}
